<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Agri Product Sale and Marketing/ Market Quota
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 6">
        <b-tab-item label="ຕະຫຼາດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການຕະຫຼາດແຂວງ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="20%">
                        ຊື່ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ແຂວງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເມືອງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ບ້ານ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈຳນວນວັນ<br>
                        ທີ່ປ້ອນໂຄຕາ
                      </th>
                      <th class="has-text-left " width="30%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in activemarkets" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.MARTKETNAME }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }}
                      </td>
                      <td>
                        {{ data.DISTRICT }}
                      </td>
                      <td>
                        {{ data.VILLAGE }}
                      </td>
                      <td  class="has-text-centered">
                        {{ data.COUNTDATE}}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                marketquotadetailform(data.ID, data.MARTKETNAME)
                              "
                              >ກຳນົດໂຄຕາ
                            </b-button>
                          </b-field>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              @click="
                                quotaToProduction(data.ID, data.MARTKETNAME)
                              "
                              >ໂຄຕ້າທີ່ສົ່ງຜະລິດ
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ຟອມໂຄຕ້າ">
          <b-field v-if="marketname === null">
            <button class="button is-info" @click="gotomarketlist">
              ເລືອກຕະຫຼາດ
            </button>
          </b-field>
          <b-field v-else>
            <div class="columns">
              <div class="column">
                <h3 class="title">{{ marketname }}</h3>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="ຟອມໂຄຕ້າ"></b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field class="group" >
                  <b-field label="ວັນທີ" style="margin-right: 15px;"> </b-field>
                  <b-field>
                    <b-datepicker
                      :date-formatter="dateFormatter"
                      v-model="selecteddate"
                      @input="onSelecteddate"
                    >
                    </b-datepicker>
                  </b-field>
                </b-field>
              </div>
              <div class="column"></div>
            </div>
            <b-tabs v-model="activeSubTab">
              <b-tab-item
                :label="type.TYPENAME"
                v-for="type in productType"
                :key="type.TYPEID"
              >
                <div class="columns">
                  <div class="column has-text-right">
                    ສິນຄ້າ
                  </div>
                  <div class="column">
                    ຈຳນວນ
                  </div>
                  <div class="column">
                    ຫົວໜ່ວຍ
                  </div>
                  <div class="column"></div>
                  <div class="column"></div>
                  <div class="column"></div>
                </div>

                <div :label="type.TYPENAME">
                  <b-filed v-for="product in products" :key="product.PRODUCTID">
                    <div class="columns" v-if="type.TYPEID === product.TYPEID">
                      <div class="column has-text-right">
                        {{ product.PRODUCTNAME }}
                      </div>
                      <div class="column">
                        <b-field v-if="product.MRAMOUNT === null">
                          <b-input v-model.trim="product.AMOUNT"> </b-input>
                        </b-field>
                        <b-feild v-else>
                          <b-input
                            v-model.trim="product.MRAMOUNT"
                            disabled="disabled"
                          >
                          </b-input>
                        </b-feild>
                      </div>
                      <div class="column">
                        <b-field group>
                          <b-field>
                            {{ product.UNIT }}
                          </b-field>
                        </b-field>
                      </div>
                      <div class="column">
                        <b-field group>
                          <b-field
                            v-if="product.MRSTATUS == 2"
                            style="margin: 0 10px 0 10px; color: red"
                          >
                            ສົ່ງຜະລິດແລ້ວ
                          </b-field>
                        </b-field>

                        <b-field
                          v-if="product.MRSTATUS == 1"
                          style="margin: 0 10px 0 10px;"
                        >
                          <b-button
                            class="btn-group-margin"
                            type="is-warning"
                            size="is-small"
                            @click="unSetProductAmount(product.PRODUCTID)"
                            >ລ້າງໂຄຕາ
                          </b-button>
                          <b-button
                            class="btn-group-margin"
                            type="is-info"
                            size="is-small"
                            @click="setProductToProduction(product.MRID)"
                            >ສົ່ງຜະລິດ
                          </b-button>
                        </b-field>
                      </div>

                      <div class="column"></div>
                    </div>
                  </b-filed>
                </div>

                <div class="columns">
                  <div class="column"></div>

                  <div class="column">
                    <b-field group>
                      <b-field>
                        <b-button
                          class="btn-group-margin"
                          type="is-primary"
                          size="is-small"
                          @click="saveProductAmount()"
                          >ບັນທືກ
                        </b-button>
                      </b-field>
                      <b-field>
                        <b-button
                          class="btn-group-margin"
                          type="is-warning"
                          size="is-small"
                          @click="unSetProductsAmount(type.TYPEID)"
                          >ລ້າງໂຄຕາ
                        </b-button>
                      </b-field>
                      <b-field>
                        <b-button
                          class="btn-group-margin"
                          type="is-info"
                          size="is-small"
                          @click="setProductsToProduction(type.TYPEID)"
                          >ສົ່ງຜະລິດ
                        </b-button>
                      </b-field>
                    </b-field>
                  </div>

                  <div class="column"></div>
                  <div class="column"></div>
                </div>
              </b-tab-item>
            </b-tabs>
          </b-field>
        </b-tab-item>

        <b-tab-item label="ໂຄຕາທີ່ສົ່ງຜະລິດ">
          <b-field v-if="marketname === null">
            <button class="button is-info" @click="gotomarketlist">
              ເລືອກຕະຫຼາດ
            </button>
          </b-field>
          <b-filed v-else>
            <div class="columns">
              <div class="column">
                <h3 class="title">{{ marketname }}</h3>
              </div>
            </div>
            <b-tabs v-model="activeQuotaSubTab">
              <b-tab-item  label="ໂຄຕາທີ່ສົ່ງຜະລິດ"> 
                <div class="columns scrollme">
                  <div class="column">
                    <b-field >
                      <table class="table is-fullwidth is-narrow is-small">
                        <thead>
                          <tr>
                            <th class="has-text-centered " width="5%">#</th>
                            <th class="has-text-left " width="15%">
                              ວັນທີ
                            </th>
                            <th class="has-text-left " width="15%">
                              ຈຳນວນປະເພດ
                            </th>
                            <th class="has-text-left " width="15%">
                              ຈຳນວນສິນຄ້າ
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(data, index) in quotaltoproduction" :key="data.REDATE">
                            <td class="has-text-centered">{{ index + 1 }}</td>
                            <td>
                               <a @click='quotadatededtailtab(data.REDATE)'>{{ dateFormatter(data.REDATE) }}</a>
                            </td>
                            <td>
                              {{ data.COUNTTYPE }}
                            </td>
                            <td>
                              {{ data.COUNTPRODUCT }}
                            </td>
                            
                          </tr>
                        </tbody>
                      </table>
                    </b-field>
                  </div>
                </div>
              </b-tab-item>
              <b-tab-item  label="ລາຍລະອຽດ"> 
                <b-field v-if="quotadate === null">
                  <button class="button is-info" @click="gotoquotadate">
                    ເລືອກວັນທີ
                  </button>
                </b-field>
                <b-filed v-else>
                    <b-field label="ວັນທີ" style="margin-right: 15px;"> </b-field>
                    <b-field>
                      <b-datepicker
                        :date-formatter="dateFormatter"
                        v-model="selectedquotaddate"
                        @input="onSelectedquotaldate"
                      >
                      </b-datepicker>
                    </b-field>
                    <b-filed v-for="quotadatetype in quotadatetypes" :key="quotadatetype.TYPEID">
                      
                      
                        <div class="column">
                          {{ quotadatetype.TYPENAME }}
                     
                            <table class="table is-fullwidth is-narrow is-small">
                              <thead>
                                <tr>
                                  <th class="has-text-centered " width="5%">#</th>
                                  <th class="has-text-left " width="15%">
                                    ສິນຄ້າ
                                  </th>
                                  <th class="has-text-left " width="15%">
                                    ໂຄຕ້າ
                                  </th>
                                  <th class="has-text-left " width="15%">
                                    ກຳລັງຜະລິດ
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="quotadateproduct in quotadateproducts" :key="quotadateproduct.PRODUCTID" >
                                  <td class="has-text-centered" v-if="quotadatetype.TYPEID === quotadateproduct.TYPEID">{{ quotadateproduct.NUM }}</td>
                
                                  <td v-if="quotadatetype.TYPEID === quotadateproduct.TYPEID">
                                    {{quotadateproduct.PRODUCTNAME}}
                                  </td>
                                  <td v-if="quotadatetype.TYPEID === quotadateproduct.TYPEID">
                                    {{quotadateproduct.AMOUNT}} {{quotadateproduct.UNIT}}
                                  </td>
                                  <td v-if="quotadatetype.TYPEID === quotadateproduct.TYPEID">
                                    
                                  </td>
                                  
                                </tr>
                              </tbody>
                            </table>
                          <!-- <b-filed class="columns" v-if="type.TYPEID === product.TYPEID">
                            </b-filed> -->
                        </div>
                      
                    </b-filed>
      

                </b-filed>

              </b-tab-item>
            </b-tabs>
            
          </b-filed>
          
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  // components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activemarkets: [],
      inactivemarkets: [],
      marketid: null,
      marketname: null,

      activeTab: 0,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      activeSubTab: 0,
      productType: [],
      products: [],
      productamount: [],
      selecteddate: null,

      quotaltoproduction: [],
      activeQuotaSubTab: 0,
      quotadate: null,
      quotadatetypes: null,
      quotadateproducts: null,
      selectedquotaddate: null,
  
    };
  },
  methods: {
    saveForm() {
      // console.log("this.selectedProvince.ID: " + this.selectedProvince.length)
      if (
        this.marketname === null ||
        this.selectedProvince === null ||
        this.district === null ||
        this.village === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          marketname: this.marketname,
          provinceid: this.selectedProvince.ID,
          district: this.district,
          village: this.village,
          username: this.username
        };
        RestAPI.saveMarket(params)
          .then(res => {
            // console.log("data: " + JSON.stringify(res.data))
            if (res.data == "duplicate marketname") {
              this.$swal("ຊື່ຕະຫຼາດຊ້ຳ", "-", "error");
              return false;
            }

            this.$swal("ສ້າງຕະຫຼາດ ສຳເລັດ!", "", "success");

            this.activeTab = 2;
            this.saveAction = true;
            this.updateAction = false;
            this.marketname = null;
            this.selectedProvince = null;
            this.district = null;
            this.village = null;
            this.getMarkets();
            this.activeTab = 1;
            // console.log(res);
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getMarkets() {
      RestAPI.getMarkets()
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.activemarkets = res.data.activemarkets;
          this.inactivemarkets = res.data.inactivemarkets;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProductType() {
      RestAPI.getProductType()
        .then(res => {
          this.productType = res.data.activeProductType;
          // console.log("prodcuttype: " + JSON.stringify(this.productType));
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProducts() {
      RestAPI.getProducts(
        this.marketid,
        this.dateFormatterYYYYMMDD(this.selecteddate)
      )
        .then(res => {
          this.products = res.data;
          // console.log("products: " + JSON.stringify(this.products));
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    marketquotadetailform(ID, MARTKETNAME) {
      this.activeTab = 1;
      this.marketid = ID;

      this.marketname = MARTKETNAME;
      this.getProducts();
      // console.log("marketid: " + this.marketid);
      // console.log("redate: " + this.dateFormatterYYYYMMDD(this.selecteddate));
    },
    gotomarketlist() {
      this.activeTab = 0;
    },
    quotaToProduction(ID, MARTKETNAME){
      this.activeTab = 2;
      this.marketid = ID;
      this.marketname = MARTKETNAME;
      
      RestAPI.getProductToProduction(this.marketid)
        .then(res => {
          this.quotaltoproduction = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    gotoquotadate() {
      this.activeQuotaSubTab = 0;
    },
    
    onSelecteddate() {
      this.getProducts();
      // this.formdate = this.dateFormatterYYYYMMDD(this.selecteddate);
      // console.log(this.formdate);
    },
    onSelectedquotaldate() {
      this.quotadatededtailtab(this.dateFormatterYYYYMMDD(this.selectedquotaddate))
      console.log("this.dateFormatterYYYYMMDD(this.selectedquotaddate): " + this.dateFormatterYYYYMMDD(this.selectedquotaddate))
    },
    saveProductAmount() {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selecteddate),
        marketid: this.marketid,
        products: this.products,
        username: this.username
      };

      // console.log("params: ", JSON.stringify(params))

      RestAPI.saveProductAmount(params)
        .then(() => {
          this.$swal("ບັນທືກ ສຳເລັດ!", "", "success");
          this.getProducts();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    unSetProductsAmount(type) {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selecteddate),
        marketid: this.marketid,
        typeid: type,
        username: this.username
      };

      RestAPI.unSetProductsAmount(params)
        .then(() => {
          this.$swal("ລ້າງໂຄຕ້າ ສຳເລັດ!", "", "success");
          this.getProducts();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    unSetProductAmount(productid) {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selecteddate),
        marketid: this.marketid,
        productid: productid,
        username: this.username
      };

      RestAPI.unSetProductAmount(params)
        .then(() => {
          this.$swal("ລ້າງໂຄຕ້າ ສຳເລັດ!", "", "success");
          this.getProducts();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    setProductsToProduction(typeid){
      var params = {
        typeid: typeid,
        redate: this.dateFormatterYYYYMMDD(this.selecteddate),
        username: this.username
      };

      console.log("par: "+ JSON.stringify(params))

      RestAPI.setProductsToProduction(params)
        .then(() => {
          this.$swal("ສົ່ງຜະລິດ ສຳເລັດ!", "", "success");
          this.getProducts();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    setProductToProduction(mrid) {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        mrid: mrid,
        username: this.username
      };

      RestAPI.setProductToProduction(params)
        .then(() => {
          this.$swal("ສົ່ງຜະລິດ ສຳເລັດ!", "", "success");
          this.getProducts();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    quotadatededtailtab(redate){
      console.log("redate: "+ redate)
      this.quotadate = redate; 
      this.activeQuotaSubTab = 1;
      RestAPI.getquotadatededtail(this.marketid, this.quotadate)
        .then(res => {
          this.quotadatetypes = res.data.quotadatetypes;
          this.quotadateproducts = res.data.quotadateproducts;
          console.log(this.quotadateproducts)
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });

    },
    // openSaveMarketForm() {
    //   this.activeTab = 0;
    //   this.saveAction = true;
    //   this.updateAction = false;
    //   this.marketname = null;
    //   this.selectedProvince = null;
    //   this.district = null;
    //   this.village = null;
    // },
    // updateMarket() {
    //   if (
    //     this.martketname === null ||
    //     this.selectedProvince === null ||
    //     this.district === null ||
    //     this.village === null
    //   ) {
    //     this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
    //   }
    //   var params = {
    //     oldmarketname: this.oldbranchname,
    //     marketid: this.marketid,
    //     marketname: this.marketname,
    //     provinceid: this.selectedProvince.ID,
    //     district: this.district,
    //     village: this.village,
    //     username: this.username
    //   };

      // console.log("pa: " + JSON.stringify(params))

    //   RestAPI.updateMarket(params)
    //     .then(res => {
    //       // console.log("data: "+ JSON.stringify(res.data))
    //       if (res.data == "duplicate marketname") {
    //         this.$swal("ຊື່ຕະຫຼາດຊ້ຳ", "-", "error");
    //         return false;
    //       }

    //       this.$swal("ອັບເດດຕະຫຼາດ ສຳເລັດ!", "", "success");

    //       this.activeTab = 1;
    //       this.saveAction = true;
    //       this.updateAction = false;
    //       this.marketname = null;
    //       this.selectedProvince = null;
    //       this.district = null;
    //       this.village = null;
    //       this.getMarkets();
    //     })
    //     .catch(error => {
    //       console.log(error);
    //       if (error == "Error: Request failed with status code 400") {
    //         this.$swal("Check Input Data", "", "error");
    //       } else {
    //         this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
    //       }
    //     });
    // },
    // changeSataus(id, status) {
    //   this.$swal({
    //     title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
    //     showCancelButton: true,
    //     showCloseButton: true,
    //     confirmButtonText: "ຕ້ອງການ",
    //     cancelButtonText: "ບໍ່ຕ້ອງການ",
    //     confirmButtonColor: "#d33",
    //     cancelButtonColor: "#3085d6"
    //   }).then(result => {
    //     if (result.value) {
    //       var params = {
    //         table: "market",
    //         id: id,
    //         status: status,
    //         username: this.username
    //       };
    //       RestAPI.changeSataus(params)
    //         .then(() => {
    //           this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");
    //           this.getMarkets();
    //         })
    //         .catch(error => {
    //           this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
    //         });
    //     }
    //   });
    // },
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    }
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.getMarkets();
    this.getProductType();
    this.selecteddate = new Date();
    this.selectedquotaddate = new Date();
    this.formdate = new Date();
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
